export default function AgeResult({ result }) {
    return (
      <div className="mt-4">
        {result ? (
          <div className="alert alert-success">
            You are <strong>{result.years}</strong> years, <strong>{result.months}</strong> months and <strong>{result.days}</strong> days old.
          </div>
        ) : (
          <div className="alert alert-info">Enter your date of birth to calculate age.</div>
        )}
      </div>
    );
  }
  